import { useState } from 'react';
import { MOOD_META } from '../utils';

export default function MoodWidget({ onSave }) {
  const [score, setScore] = useState(null);
  const [note, setNote] = useState('');
  const [saving, setSaving] = useState(false);
  const [savedAt, setSavedAt] = useState(null);

  async function save() {
    if (!score) return;
    setSaving(true);
    try {
      await onSave(score, note);
      setSavedAt(Date.now());
      setNote('');
      setScore(null);
      setTimeout(() => setSavedAt(null), 2400);
    } finally {
      setSaving(false);
    }
  }

  return (
    <section className="mood-widget" aria-labelledby="mood-widget-title">
      <h2 className="mood-widget__title" id="mood-widget-title">
        How are you?
      </h2>
      <div className="mood-widget__scale" role="group" aria-label="Mood, from rough to great">
        {[1, 2, 3, 4, 5].map((n) => {
          const meta = MOOD_META[n];
          const active = score === n;
          return (
            <button
              key={n}
              type="button"
              onClick={() => setScore(n)}
              className={`mood-widget__btn${active ? ' mood-widget__btn--active' : ''}`}
              style={active ? { borderColor: meta.color, color: meta.color } : undefined}
              aria-pressed={active}
            >
              <span className="mood-widget__emoji" aria-hidden="true">
                {meta.emoji}
              </span>
              <span className="mood-widget__label">{meta.label}</span>
            </button>
          );
        })}
      </div>
      {score && (
        <>
          <input
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="A word or two? (optional)"
            aria-label="Optional note about your mood"
            className="mood-widget__note"
            maxLength={140}
          />
          <button className="mood-widget__save" onClick={save} disabled={saving}>
            {saving ? 'Saving…' : 'Save'}
          </button>
        </>
      )}
      <p className="mood-widget__confirm" role="status">
        {savedAt ? 'Logged.' : ''}
      </p>
    </section>
  );
}
